module.exports = __webpack_public_path__ + "img/04.6f3af743.png";